import { ProviderButton as ProviderButtonComponent } from "./provider-button";
import { ProviderButtonSkeleton } from "./provider-button-skeleton";

export const ProviderButton = Object.assign(ProviderButtonComponent, {
  Skeleton: ProviderButtonSkeleton,
});
